import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from '@/store/hooks';

import { initialState, XSOLIS_USER_TYPE } from './User.constants';
import { UserProfile, UserProfileResponse } from './User.types';

const UserSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    RESET() {
      return initialState;
    },
    SET_USER(state, action: PayloadAction<UserProfileResponse>) {
      const {
        allowSaveWithoutTeam,
        applicationUserId,
        block_alerts,
        enabled,
        first_name,
        font_size_multiplier,
        isDragonflyUser,
        isGenAiP2pPaClinicalSummaryEnabled,
        last_name,
        main_organization_id,
        main_organization_name,
        phone_number,
        use_auto_save,
        user_roles,
        user_teams,
        user_type_id,
        username,
      } = action.payload;

      state.font_size_multiplier = font_size_multiplier ?? 0;
      state.isDragonflyUser = isDragonflyUser;
      state.user_type_id = user_type_id;
      state.use_auto_save = use_auto_save;
      state.allowSaveWithoutTeam = allowSaveWithoutTeam;
      state.applicationUserId = applicationUserId;
      state.block_alerts = block_alerts;
      state.enabled = enabled;
      state.first_name = first_name;
      state.last_name = last_name;
      state.main_organization_id = main_organization_id;
      state.main_organization_name = main_organization_name;
      state.phone_number = phone_number;
      state.username = username;
      state.user_roles = user_roles ?? [];
      state.user_teams = user_teams ?? [];
      state.isXsolisUser = user_type_id === XSOLIS_USER_TYPE;
      state.isGenAiP2pPaClinicalSummaryEnabled =
        isGenAiP2pPaClinicalSummaryEnabled;
    },
    SET_USER_AUTO_SAVE(
      state,
      action: PayloadAction<UserProfile['use_auto_save']>
    ) {
      state.use_auto_save = action.payload;
    },
    SET_USER_FONT_SIZE_MULTIPLIER(
      state,
      action: PayloadAction<UserProfile['font_size_multiplier']>
    ) {
      state.font_size_multiplier = action.payload;
    },
  },
});

export const userReducer = UserSlice.reducer;
export const userActions = UserSlice.actions;

export function useUserSelector(): UserProfile {
  return useAppSelector((state) => state.user);
}
